import { React, ts } from '_core';

import Chart from './chart';
import { Params } from './types';

type RiskModelBiasStatisticByBetaProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  setParams: (_p: Params) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.riskModel.RiskModelAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_bias_statistic_by_beta', string>;
};

const RiskModelBiasStatisticByBeta = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: RiskModelBiasStatisticByBetaProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['risk_model_bias_statistic_by_beta']}
      fullScreen={fullScreen}
      title={title}
    />
  );
};

export default RiskModelBiasStatisticByBeta;
